export enum ChatWindowMode {
  LAYERED = 'LAYERED',
  POP_UP = 'POP_UP'
}
